module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-5.1061ee15.png";